import {
  SET_PRESET_MESSAGES,
  RESET_PRESET_MESSAGES,
} from '../../mutation-types';

const mutations = {
  [SET_PRESET_MESSAGES](state, presetMessages) {
    state.presetMessages = presetMessages;
  },
  [RESET_PRESET_MESSAGES](state) {
    state.presetMessages = [];
  },
};

export default mutations;
